export const DONT_SHOW_LOAD_WORKSPACE_DIALOG_AGAIN = 'dontShowLoadWorkspaceDialogAgain';
